import getDatesIntervalWithSubtractMinutes from '../../../localUtils/getDatesIntervalWithSubtractMinutes'

export default function getTwelveHoursAgo() {
  const getTwelveHoursAgo = 12 * 60

  const dates = getDatesIntervalWithSubtractMinutes(getTwelveHoursAgo)

  const options = {
    name: 'TWELVE_HOURS_AGO',
    label: '12 horas',
    ...dates,
  }

  return options
}
